import Vue from 'vue';

//引入基本模板
let echarts = require('echarts/lib/echarts')

// 引入折线图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/map')
require('echarts/lib/chart/scatter')
require('echarts/lib/chart/effectScatter')


// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/geo')
require('echarts/lib/component/visualMap')

//引入中国、各省地图
// resolve => require(['echarts/map/js/china'], resolve)//懒加载
// require('echarts/map/js/china')
// require('echarts/map/js/province/anhui')
// require('echarts/map/js/province/aomen')
// require('echarts/map/js/province/beijing')
// require('echarts/map/js/province/chongqing')
// require('echarts/map/js/province/fujian')
//
// require('echarts/map/js/province/gansu')
// require('echarts/map/js/province/guangdong')
// require('echarts/map/js/province/guangxi')
// require('echarts/map/js/province/guizhou')
// require('echarts/map/js/province/hainan')
//
// require('echarts/map/js/province/hebei')
// require('echarts/map/js/province/heilongjiang')
// require('echarts/map/js/province/henan')
// require('echarts/map/js/province/hubei')
// require('echarts/map/js/province/hunan')
//
// require('echarts/map/js/province/jiangsu')
// require('echarts/map/js/province/jiangxi')
// require('echarts/map/js/province/jilin')
// require('echarts/map/js/province/liaoning')
// require('echarts/map/js/province/neimenggu')
//
// require('echarts/map/js/province/ningxia')
// require('echarts/map/js/province/qinghai')
// require('echarts/map/js/province/shandong')
// require('echarts/map/js/province/shanghai')
// require('echarts/map/js/province/shanxi')
//
// require('echarts/map/js/province/shanxi1')
// require('echarts/map/js/province/sichuan')
// require('echarts/map/js/province/taiwan')
// require('echarts/map/js/province/tianjin')
// require('echarts/map/js/province/xianggang')
//
// require('echarts/map/js/province/xinjiang')
// require('echarts/map/js/province/xizang')
// require('echarts/map/js/province/yunnan')
// require('echarts/map/js/province/zhejiang')



Vue.prototype.$echarts = echarts;
